import { enhancedApi } from '@store/generated/waiting-room';

const WAITING_ROOM_TAG_TYPES = ['WaitingRoomLink', 'WaitingRoomQueue'] as const;

export const waitingRoomApi = enhancedApi.enhanceEndpoints({
  addTagTypes: WAITING_ROOM_TAG_TYPES,
  endpoints: {
    getV2ProviderWaitingRoomLink: {
      providesTags: [{ type: 'WaitingRoomLink', id: 'CURRENT' }],
    },
    getV2ProviderWaitingRoomQueue: {
      providesTags: [{ type: 'WaitingRoomQueue', id: 'LIST' }],
    },
    putV2ProviderWaitingRoomAvailability: {
      invalidatesTags: [{ type: 'WaitingRoomQueue', id: 'LIST' }],
    },
    postV2ProviderWaitingRoomQueueByEntryIdAdmit: {
      invalidatesTags: [{ type: 'WaitingRoomQueue', id: 'LIST' }],
    },
    postV2ProviderWaitingRoomQueueByEntryIdAdmitAdditional: {
      invalidatesTags: [{ type: 'WaitingRoomQueue', id: 'LIST' }],
    },
    postV2ProviderWaitingRoomEncountersByEncounterIdJoin: {
      invalidatesTags: [{ type: 'WaitingRoomQueue', id: 'LIST' }],
    },
    deleteV2ProviderWaitingRoomQueueByEntryId: {
      invalidatesTags: [{ type: 'WaitingRoomQueue', id: 'LIST' }],
    },
  },
});

export const {
  useGetV2ProviderWaitingRoomLinkQuery: useGetProviderWaitingRoomLinkQuery,
  useGetV2ProviderWaitingRoomQueueQuery: useGetProviderWaitingRoomQueueQuery,
  usePutV2ProviderWaitingRoomAvailabilityMutation: useSetProviderWaitingRoomAvailabilityMutation,
  usePostV2ProviderWaitingRoomHeartbeatMutation: useProviderWaitingRoomHeartbeatMutation,
  usePostV2ProviderWaitingRoomQueueByEntryIdAdmitMutation: useAdmitWaitingRoomPatientMutation,
  usePostV2ProviderWaitingRoomQueueByEntryIdAdmitAdditionalMutation:
    useAdmitAdditionalWaitingRoomPatientMutation,
  usePostV2ProviderWaitingRoomEncountersByEncounterIdJoinMutation:
    useJoinWaitingRoomEncounterMutation,
  useDeleteV2ProviderWaitingRoomQueueByEntryIdMutation: useRemoveWaitingRoomPatientMutation,
} = waitingRoomApi;
